<template>
  <div class="col">
    <h1 style="font-family: 'Virgula Vulgaris'">Carta astral</h1>
    <p class="main-description">
      Este mapa te ayudará a entender mejor tu forma de ser y comportamiento, así como el contexto que te rodea.
    </p>

    <a v-if="data.astral_card"  href="https://rubenjungbluth.com/servicios/guia-para-interpretarla/" target="_blank">Conoce cómo interpretar tu carta astral aquí.</a>

    <v-row class="mb-5">
      <v-col>
        <v-btn v-if="data.astral_card" :to="{name: 'Appoinments', params: { openAlert: true }}" color="primary" large class="white--text">Solicitar consulta</v-btn>
				<v-btn v-if="!data.astral_card && btnAstralCard" @click="verifyDataCompleted" color="primary" large class="white--text">Solicitar carta astral</v-btn>
				<!--<hr v-if="!data.astral_card && !btnAstralCard"/>-->
				<p v-if="!data.astral_card && !btnAstralCard" class="main-description">Gracias por solicitar tu carta astral, estamos atendiendo tu solicitud.</p>
			</v-col>
    </v-row>

    <v-row class="img-astral-card">
      <v-col class="ctn-astral-card" v-if="data.astral_card">
        <!--<v-card>-->
          <v-img :src="data.astral_card.file_url"></v-img>
        <!--</v-card>-->
      </v-col>
    </v-row>
		<p class="disclamer">
			Si su carta astral no muestra los datos correctos, actualiza la información en
			<router-link :to="{name: 'Profile'}">tu perfil</router-link> y escríbenos a contacto@rubenjungbluth.com
		</p>
		<v-dialog v-model="flagModal" persistent max-width="470px" v-cloak>
			<v-card class="dialog-appointment">
				<v-btn class="mx-2 close-btn" x-small fab dark @click="flagModal = !flagModal" color="secondary lighten-3">
					<v-icon >mdi-close</v-icon>
				</v-btn>
				<v-card-title class="text-center">
					<img
							src="../assets/alert.png"
							alt="logo"
							class="logo"
					>
				</v-card-title>
				<v-card-text class="text-center mt-4 pb-4">
					Se necesitan completar datos para solicitar tu carta astral. <br/> <router-link class="text-decoration-none" style="color: #43A4BB;" :to="{name: 'Profile'}">Ingresa a tu perfil,</router-link> actualiza tus datos y regresa aquí.
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="modalSuccess" persistent max-width="570px" v-cloak>
			<v-card class="dialog-appointment">
				<v-btn class="mx-2 close-btn" x-small fab dark @click="modalSuccess = !modalSuccess" color="secondary lighten-3">
					<v-icon >mdi-close</v-icon>
				</v-btn>
				<v-card-title class="text-center">
					<img
							src="../assets/logo.png"
							alt="logo"
							class="logo"
					>
				</v-card-title>
				<v-card-text>
					<p class="text-center modal-text">
						Gracias por solicitar tu carta astral. <br/>
						En un máximo de 48 horas hábiles podrás visualizarla en <span>este espacio.</span>
					</p>
				</v-card-text>
			</v-card>
		</v-dialog>
  </div>
</template>
<script>
  import {mapActions, mapState} from "vuex";

export default {
  name: 'AstralCard',
	data() {
		return {
		flagModal: false,
		modalSuccess: false,
		btnAstralCard: true
		}
	},
  computed: {
    ...mapState('astralCard',[
      'data']),
    ...mapState('user',[
      'info',
    ]),
  },
  methods : {
    ...mapActions(
        'astralCard', [
          'fetchData',
					'requestCard'
        ]
    ),
    ...mapActions(
        'user', [
          'fetchInfo',
        ]
    ),
    ...mapActions(['loaderChange']),
    verifyDataCompleted() {
      this.loaderChange(true)
			this.fetchInfo()
				.then(() => {
					let user = this.info.user_data
					let _isComplete = user.birth_date && user.names && user.surnames && user.born_country && user.born_place ? true: false
					if (_isComplete) {
						this.sendMail()
						localStorage.setItem('astralCard', false)
						this.btnAstralCard = false
					} else {
						this.showModalNeedInfo()
            this.loaderChange(false)
					}
				})
		},
		sendMail() {
			this.requestCard().finally(() => {
				this.loaderChange(false)
        this.modalSuccess = true
			})
		},
    showModalNeedInfo() {
      this.flagModal = true
		}
  },
  mounted() {
    if (localStorage.getItem("astralCard")) {
      this.btnAstralCard = false
    }
    this.loaderChange(true)
    this.fetchData().finally(() => {
      this.loaderChange(false)
    })
    if (!localStorage.getItem('token')) {
      sessionStorage.setItem('url', window.location.href);
    }
  }
}
</script>
<style lang="scss" scoped>
	* {
		font-family: "Avenir", sans-serif;
		color: #656565;
	}
  .img-astral-card {
		margin-bottom: 100px;
		margin-top: 30px;
  }
	a {
		font-size: 16px;
		color: #2C8886;
	}
	::v-deep .v-btn {
		text-transform: unset;
		font-family: "Avenir";
		font-weight: 600;
		letter-spacing: normal;
		font-size: 14px;
		height: 40px;
		width: 160px;
		margin-top: 5px;
		border-radius: 7px;
		letter-spacing: 0;
		text-transform: none;
	}
	.container.fill-height.rj .main-description {
		margin-bottom: 12px;
	}
	.main-description.disclamer {
		position: absolute;
		bottom: 0;
	}
  .ctn-astral-card {
    max-width: 550px;
    padding: 20px;
		::v-deep .v-responsive__content {
			width: 100%;
		}
  }
	.disclamer {
		position: absolute;
		bottom: 10px;
		font-weight: 200;
		max-width: 90%;
	}

	.ctn-img {
		margin-top: 40px;
		img {
			width: 75px;
		}
	}
	.close-btn {
		position: absolute;
	}
</style>
